<template>
  <div>
    <div class="order-state">
        <div class="order-state-content">
            <el-steps :active="activeStep" align-center>
                <el-step
                v-for="(item, idx) in stepList"
                :key="idx"
                :title="item.title"
                >
                <template slot="icon" >
                    <i class="iconfont" :class=" getIcon(idx, item)" ></i>
                </template>
                </el-step>
            </el-steps>
        </div>
        <!-- 当前状态 -->
        <div class="order-state-current">
            <template v-for="(item,index) in orderState">
            <div class="order-state-current-img" v-if="item.status==(orderDetail.deal_time==0&&orderDetail.status==99?98:orderDetail.status)" :key="index">
                <img :src="'/images/orderState/'+item.img" alt="">
            </div>
            </template>
            <template v-for="item in orderState">
                
                <div class="order-state-current-content"   v-if="item.status==(orderDetail.deal_time==0&&orderDetail.status==99?orderDetail.ask_type==1?101:98:orderDetail.status)" :key="item.status">
                        <div class="order-state-current-title">当前状态:<span>{{item.name}}</span></div>
                        <div class="order-state-current-desc">
                            <span>{{item.desc}}</span>
                            <span class="introduction" v-if="orderDetail.status==99">{{orderDetail.cancel_remark}}</span>
                            <span class="introduction" v-else>{{item.introduction}}</span>
                        </div>
                </div>
            </template>
        </div>
    </div>
  </div>
</template>

<script>

export default {
  name: '',
  components: {},
  props: {
    orderDetail: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
        activeStep:-1, // 当前激活下标
        stepList: [
            { title: '询价中' ,icon:'icon-ask' },
            { title: '待入住' ,icon:'icon-shoulinbao'},
            { title: '已入住' ,icon:'icon-danrenchuang'},
            { title: '已离店' ,icon:'icon-lidian'},
            { title: '完成'  ,icon:'icon-complete-fill'}
        ],
        orderState:[    
            {name:'待审核',status:'1',img:'state_1.jpg',desc:'订单待审核，等待管理员审核',introduction:'耐心等候片刻'},
            {name:'待匹配',status:'2',img:'state_1.jpg',desc:'订单待匹配，等待管理员操作',introduction:'耐心等候片刻'},
            {name:'待推送',status:'3',img:'state_1.jpg',desc:'订单待推送，等待管理员操作',introduction:'耐心等候片刻'},
            {name:'询价中',status:'4',img:'state_1.jpg',desc:'订单询价中，等待酒店报价',introduction:'耐心等候酒店回传报价，报价确认无误后即可成交酒店'},
            {name:'待确认',status:'5',img:'state_1.jpg',desc:'订单待确认，等待对方确认',introduction:'耐心等候确认'},
            {name:'待入住',status:'6',img:'state_2.jpg',desc:'订单已成交，等待入住',introduction:'核对入住信息，持续对接酒店，提醒客户按期到店办理入住'},
            {name:'已入住',status:'7',img:'state_3.jpg',desc:'订单已入住，客户已入住',introduction:'跟进客人在店体验，协助处理入住期间各类临时问题'},
            {name:'已离店',status:'8',img:'state_4.jpg',desc:'订单已离店，客人离店退房',introduction:'整理本次入住台账，做好客户回访与后续维护工作'},
            {name:'已完成',status:'9',img:'state_4.jpg',desc:'订单已完成，客户已确认',},
            {name:'取消',status:'99',img:'state_5.jpg',desc:'取消原因',introduction:'订单已被取消，可尝试重新下单'},
            {name:'结束询价',status:'98',img:'state_6.jpg',desc:'结束原因',introduction:'订单已结束询价，不在接收报价'}, 
            {name:'结束确认',status:'101',img:'state_6.jpg',desc:'结束原因',introduction:'订单确认已结束，不在接收确认'},            
        ]
    };
  },
  computed: {},
  watch: {
    orderDetail: {
      handler(newVal, oldVal) {
        let index = -1; // 当前激活下标
       switch (newVal.status) {
            case '4':
                index=1 ;
            break;
            case '5':
                index=1;
            break;
            case '6':
                index=2;
            break;
            case '7':
                index=3;
            break;
            case '8':
                index=4;
            break;
            case '9':
                index=5;
            break;
        }
        this.activeStep = index;
        //待确认订单初始为待确认
        if(newVal.ask_type=='1'){
            this.stepList[0].title='待确认'
        }
      },
      deep: true
    }
  },
  created() {},
  mounted() {},
  methods: {
    getIcon(index,item) {
      // 已完成：index < activeStep
      if (index < this.activeStep) return 'icon-duihao'
      // 当前步骤：index === activeStep
      if (index === this.activeStep) return item.icon
      // 未开始
      return item.icon
    }
  }
};
</script>

<style lang="scss" scoped>
    .order-state{
        display: flex;
        margin-top: 20px;
        justify-content: space-between;
    }
    .order-state-content{
        width: 67%;
        padding: 36px 0;
        background-color: #fff;
        border-radius: 6px;
    }
    .iconfont{
        font-size: 24px;
    }
    .order-state .el-step__icon{
        width: 60px;
        height: 60px;
        
    }
    .order-state-current{
        width: 32%;
        background-color: #fff;
        border-radius: 6px;
        display: flex;
    }
    .order-state-current-img{
        width: 114px;
        height: 114px;
        padding:0 12px 0 20px;
        img{
            width: 100%;
            margin-top: 18px;
        }
    }
    .order-state-current-content{
        width: 75%;
        padding: 4%;
        background-color: #f2f8ff;
    }
    .order-state-current-title{
        margin-bottom: 20px;
        font-size: 16px;
        font-weight: bold;
        span{
            color: var(--smtc-color-primary);
            
        }
    }
    .order-state-current-desc{
        span{
            display: block;
            font-size: 12px;
            margin-top: 8px;
        }
    }
    .introduction{
        color: #999;
    }
</style>

<style>
    .order-state-content .el-steps--horizontal{
        width: 112%;
        margin-left: -6%;
    }
    .order-state .el-step__icon{
        width: 40px;
        height: 40px;
    }
    .order-state .el-step.is-horizontal .el-step__line{
        top: 20px;
    }

</style>